import default_attribute from './StateDefaultAttribute.js'

const getters = {
  type: state => state.type,
  metaLoaded: state => state.loaded,
  listAttributes: state => state.attributes,
  listPagination: state => state[state.type].pagination,
  listLoaded: state => state[state.type].loaded,
  listItems: state => state[state.type].items,
  listSort: state => state[state.type].sort,
  listHeaders: state => state[state.type].headers,
  listHeadersIndex: state => state[state.type].headers_index,
  listData: state => state[state.type].data,
  listDataItems: state => state[state.type].items,
  listDataItemsIndex: state => state[state.type].items_index,
  listCount: state => state[state.type].count,
  listPageCount: state => state[state.type].pageCount,
  listPage: state => state[state.type].list_req.page,
  listSeeAll: state => state[state.type].list_req.seeAll,
  listIs_report: state => state[state.type].list_req.is_report,
  listResTot: state => state[state.type].tot,
  listSearchsData: state => state[state.type].list_req.searchs,
  listSearchs: state => state[state.type].searchs,
  listActions: state => state[state.type].actions,
  listRequest: state => state[state.type].list_req,
  listItemsIndex: state => state[state.type].items_index,
  listSelection: state => state[state.type].selected,
  listAllSelected: state => state[state.type].all_selected,

  listActionModalState: state => state[state.type].action_modal_state,
  listActionMode: state => state[state.type].action_req.mode,

  listMergeModalState: state => state[state.type].merge_modal_state,
  listMergeMainId: state => state[state.type].merge_main_id,
  listMergeItems: state => state[state.type].merge_items,

  listExportModalState: state => state[state.type].export_modal_state,
  listExportMode: state => state[state.type].export_mode,

  listUniversModalState: state => state[state.type].univers_modal_state,
  listUniversMode: state => state[state.type].univers_mode,
  listUniversAction: state => state[state.type].univers_action,

  listUniversSingleModalState: state => state[state.type].univers_single_modal_state,
  listUniversSingleAction: state => state[state.type].univers_single_action,

  listRolesOrganization: state => state.attributes['7'].children,
  listAttributesOrganization: state => state.attributes['5'].children,
  listAttributesContact: state => state.attributes['62'].children,
  listAttributesGroup: state => state.attributes['6'].children,

  listAttributesEmail: state => state.attributes['1'].children,
  listAttributesPhone: state => state.attributes['2'].children,
  listAttributesAddress: state => state.attributes['3'].children,
  listAttributesCommission: state => state.attributes['2289'].children,

  listGetAttributes: (state, getters) => (type) => {
    if (type > 0 &&
    state.attributes[type] &&
    state.attributes[type].children
    ) {
      return state.attributes[type].children
    }
    return default_attribute().children
  },

  editBase: state => state.contactEdit.base,
  editData: state => state.contactEdit,
  accounts: state => state.accounts,
  auth_page_url: state => state.auth_page_url,
  logged: state => state.logged,
  token: state => state.token,
  univers: state => state.univers,
  rights: state => state.rights,
  
  orgs_index: state => state.orgs_index,
  groups_index: state => state.groups_index,
}

export default getters
